import React from 'react'
import { Switch, Route } from 'react-router'
import { ToastContainer } from 'react-toastify'

// Style
import '@assets/html/dist/css/style.css'

// Layouts
import {
  MainLayout,
  LoginLayout,
  StoreRegistrationLayout
} from './layouts'

type Props = {}

const App: React.FC<Props> = () => (
  <>
    <Switch>
      <Route exact path="/login" component={LoginLayout} />
      <Route exact path="/store-registration" component={StoreRegistrationLayout} />
      <Route path="/" component={MainLayout} />
    </Switch>
    <ToastContainer position="bottom-right" />
  </>
)

export default App
